import { customTheme } from 'components/DesktopFlightsSearch/customTheme';

export const autosTheme = {
  ...customTheme,
  searchInput: {
    ...customTheme.searchInput,
    time: {
      ...customTheme.searchInput.time,
      disabled: {
        ...customTheme.searchInput.time.disabled,
      },
      height: '42px',
      label: {
        ...customTheme.searchInput.time.label,
        marginTop: '0',
      },
    },
    travelArranger: {
      ...customTheme.searchInput.travelArranger,
      height: '56px',
      label: {
        ...customTheme.searchInput.travelArranger.label,
        marginTop: '20px',
      },
      detail: {
        ...customTheme.searchInput.travelArranger.detail,
        display: 'block',
      },
    },
  },
};
